import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { FlexRow, uiTheme } from '@framework/ui';
import { Button, Layout } from 'antd';
import clx from 'classnames';
import * as React from 'react';
import { useState } from 'react';
import styled from 'styled-components';

const { Header, Content, Sider } = Layout;

const TwoColumnsLayoutWrapper = styled(Layout)`
  position: relative;
  min-height: 100%;
`;

const LeftSider = styled(Sider)`
  &&& {
    background: ${props => props.theme.colorBgContainer};
    height: 100%;
    overflow: auto;
    z-index: 10;
    position: fixed;
    box-shadow: ${props => props.theme.boxShadowCustomLine};
  }
`;
const TitleHeader = styled(Header)`
  z-index: 9;
  padding: 0;
  position: sticky;
  top: ${props => props.theme.layoutHeaderHeight}px;
  height: auto;
  box-shadow: ${props => props.theme.boxShadow};
  padding-left: 6px;
  padding-right: 24px;
`;
const RightLayout = styled(Layout)`
  position: relative;
  min-height: 100%;
  max-width: 100%;
  margin-left: ${props => props.theme.layoutSiderWidth}px;
  transition: all 0.2s;
  &.collapsed {
    margin-left: ${props => props.theme.layoutSiderCollapsedWidth}px;
  }
`;
const TwoColumnsLayoutContent = styled(Content)`
  margin: 0;
  min-height: 280px;
  padding: 24px;
  &.no-padding {
    padding: 0;
  }
`;
const CollapseButton = styled(Button)`
  &&& {
    width: 48px;
    height: 48px;
    font-size: 16px;
  }
`;

export interface ITwoColumnsLayoutProps {
  /** La barra laterale di sinistra per il menu */
  sideMenu: React.ReactNode;
  /**
   * La barra del titolo che contiene anche il pulsante per collassare
   * il menu laterale
   */
  header?: React.ReactNode;
  /** Il contenuto della pagina */
  children: React.ReactNode;
  /** Rimuove il padding del contenuto della pagina */
  noPadding?: boolean;
}

/**
 * Layout principale del Back Office lato Amministrazione.
 */
export function TwoColumnsLayout(props: ITwoColumnsLayoutProps) {
  const [collapsed, setCollapsed] = useState(false);
  const hasTopBar = !!props.header;
  return (
    <TwoColumnsLayoutWrapper hasSider>
      <LeftSider
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={uiTheme.layoutSiderWidth}
        collapsedWidth={uiTheme.layoutSiderCollapsedWidth}
      >
        {props.sideMenu}
      </LeftSider>
      <RightLayout className={clx({ collapsed })}>
        {hasTopBar && (
          <TitleHeader>
            <FlexRow
              gutter={12}
              align="center"
              left={
                <CollapseButton
                  type="text"
                  icon={
                    collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />
                  }
                  onClick={() => setCollapsed(!collapsed)}
                />
              }
            >
              {props.header}
            </FlexRow>
          </TitleHeader>
        )}
        <TwoColumnsLayoutContent
          className={clx({ 'no-padding': props.noPadding })}
        >
          {props.children}
        </TwoColumnsLayoutContent>
      </RightLayout>
    </TwoColumnsLayoutWrapper>
  );
}
